module.exports = __webpack_public_path__ + "static/img/goods-3.e03688c5.png";